export type FontWidthMap = Record<string, number>;

/**
 * These calculations are based on specific font settings using a canvas element for the measurements.
 * Font size: '12px'
 * Font weight 400
 * Font family: 'DynatraceFlow, Roboto, Helvetica, sans-serif'
 */
export const charsFontWidth12pixelsSize400Map: FontWidthMap = {
  '0': 6.8879852294921875,
  '1': 6.8879852294921875,
  '2': 6.8879852294921875,
  '3': 6.8879852294921875,
  '4': 6.8879852294921875,
  '5': 6.8879852294921875,
  '6': 6.8879852294921875,
  '7': 6.8879852294921875,
  '8': 6.8879852294921875,
  '9': 6.8879852294921875,
  a: 6.5879974365234375,
  á: 6.5879974365234375,
  à: 6.5879974365234375,
  ä: 6.5879974365234375,
  â: 6.5879974365234375,
  ã: 6.5879974365234375,
  å: 6.5879974365234375,
  b: 6.5999908447265625,
  c: 5.7719879150390625,
  ç: 5.7719879150390625,
  d: 6.5999908447265625,
  e: 6.29998779296875,
  é: 6.29998779296875,
  è: 6.29998779296875,
  ë: 6.29998779296875,
  ê: 6.29998779296875,
  f: 4.391998291015625,
  g: 6.5279998779296875,
  h: 6.85198974609375,
  i: 3.02398681640625,
  í: 3.02398681640625,
  ì: 3.02398681640625,
  ï: 3.02398681640625,
  j: 3.1079864501953125,
  k: 6.0479888916015625,
  l: 3.39599609375,
  m: 10.727996826171875,
  n: 6.839996337890625,
  ñ: 6.839996337890625,
  o: 6.33599853515625,
  ó: 6.33599853515625,
  ò: 6.33599853515625,
  ö: 6.33599853515625,
  ô: 6.33599853515625,
  õ: 6.33599853515625,
  ø: 6.33599853515625,
  p: 6.5999908447265625,
  q: 6.61199951171875,
  r: 4.7159881591796875,
  s: 5.8079986572265625,
  š: 5.8079986572265625,
  t: 4.4399871826171875,
  u: 6.839996337890625,
  ú: 6.839996337890625,
  ù: 6.839996337890625,
  ü: 6.839996337890625,
  v: 5.855987548828125,
  w: 8.855987548828125,
  x: 5.9879913330078125,
  y: 5.7239990234375,
  ý: 5.7239990234375,
  ÿ: 5.7239990234375,
  z: 5.9639892578125,
  A: 7.5959930419921875,
  Á: 7.5959930419921875,
  À: 7.5959930419921875,
  Ä: 7.5959930419921875,
  Â: 7.5959930419921875,
  Ã: 7.5959930419921875,
  Å: 7.5959930419921875,
  B: 7.4639892578125,
  C: 7.1639862060546875,
  Ç: 7.1639862060546875,
  D: 7.4759979248046875,
  E: 6.947998046875,
  É: 6.947998046875,
  È: 6.947998046875,
  Ë: 6.947998046875,
  Ê: 6.947998046875,
  F: 6.5879974365234375,
  G: 7.4879913330078125,
  H: 8.147994995117188,
  I: 4.4759979248046875,
  Í: 4.4759979248046875,
  Ì: 4.4759979248046875,
  Ï: 4.4759979248046875,
  J: 5.4239959716796875,
  K: 7.28399658203125,
  L: 6.239990234375,
  M: 9.7919921875,
  N: 8.21998596191406,
  Ñ: 8.21998596191406,
  O: 7.67999267578125,
  Ó: 7.67999267578125,
  Ò: 7.67999267578125,
  Ö: 7.67999267578125,
  Ô: 7.67999267578125,
  Õ: 7.67999267578125,
  Ø: 7.67999267578125,
  P: 7.1999969482421875,
  Q: 7.67999267578125,
  R: 7.6079864501953125,
  S: 7.0919952392578125,
  Š: 7.0919952392578125,
  T: 6.4799957275390625,
  U: 7.8119964599609375,
  Ú: 7.8119964599609375,
  Ù: 7.8119964599609375,
  Ü: 7.8119964599609375,
  V: 7.4759979248046875,
  W: 11.327987670898438,
  X: 7.83599853515625,
  Y: 7.115997314453125,
  Ý: 7.115997314453125,
  Ÿ: 7.115997314453125,
  Z: 7.24798583984375,
  ' ': 2.9759979248046875,
  '!': 3.45599365234375,
  '"': 4.4639892578125,
  '#': 7.631988525390625,
  $: 6.899993896484375,
  '%': 8.855987548828125,
  '&': 7.6439971923828125,
  "'": 2.62799072265625,
  '(': 4.1039886474609375,
  ')': 3.8879852294921875,
  '*': 6.1439971923828125,
  '+': 6.8879852294921875,
  ',': 2.9759979248046875,
  '-': 5.6639862060546875,
  '.': 2.9759979248046875,
  '/': 4.1039886474609375,
  ':': 2.9759979248046875,
  ';': 2.9759979248046875,
  '<': 7.2119903564453125,
  '=': 6.8879852294921875,
  '>': 7.2119903564453125,
  '?': 6.5519866943359375,
  '@': 12.7919921875,
  '[': 4.055999755859375,
  '\\': 4.1039886474609375,
  ']': 3.9839935302734375,
  '^': 6.8879852294921875,
  _: 6.8159942626953125,
  '`': 3.29998779296875,
  '{': 4.4279937744140625,
  '|': 3.1199951171875,
  '}': 4.4279937744140625,
  '~': 6.8879852294921875,
  '•': 5.23199462890625,
  '…': 8.9279937744140625,
  '°': 4.511993408203125,
  µ: 6.839996337890625,
  '²': 4.12799072265625,
  '³': 4.12799072265625,
  '±': 6.8879852294921875,
  '€': 6.899993896484375,
  '£': 6.899993896484375,
  '¥': 6.8879852294921875,
};

export const charsFontWidth14pixelsSize400Map: FontWidthMap = {
  '0': 8.035995483398438,
  '1': 8.035995483398438,
  '2': 8.035995483398438,
  '3': 8.035995483398438,
  '4': 8.035995483398438,
  '5': 8.035995483398438,
  '6': 8.035995483398438,
  '7': 8.035995483398438,
  '8': 8.035995483398438,
  '9': 8.035995483398438,
  a: 7.6859893798828125,
  b: 7.6999969482421875,
  c: 6.7339935302734375,
  d: 7.6999969482421875,
  e: 7.3499908447265625,
  f: 5.123992919921875,
  g: 7.615997314453125,
  h: 7.993988037109375,
  i: 3.5279998779296875,
  j: 3.6259918212890625,
  k: 7.055999755859375,
  l: 3.9619903564453125,
  m: 12.5159912109375,
  n: 7.9799957275390625,
  o: 7.391998291015625,
  p: 7.6999969482421875,
  q: 7.7139892578125,
  r: 5.5019989013671875,
  s: 6.7759857177734375,
  t: 5.17999267578125,
  u: 7.9799957275390625,
  v: 6.8319854736328125,
  w: 10.33198547363281,
  x: 6.985992431640625,
  y: 6.6779937744140625,
  z: 6.9579925537109375,
  Á: 8.86199951171875,
  À: 8.86199951171875,
  Ä: 8.86199951171875,
  Â: 8.86199951171875,
  Ã: 8.86199951171875,
  Å: 8.86199951171875,
  Ç: 8.35798645019531,
  É: 8.105987548828125,
  È: 8.105987548828125,
  Ë: 8.105987548828125,
  Ê: 8.105987548828125,
  Í: 5.2220001220703125,
  Ì: 5.2220001220703125,
  Ï: 5.2220001220703125,
  Ñ: 9.589996337890625,
  Ó: 8.959991455078125,
  Ò: 8.959991455078125,
  Ö: 8.959991455078125,
  Ô: 8.959991455078125,
  Õ: 8.959991455078125,
  Ø: 8.959991455078125,
  Š: 8.27398681640625,
  Ý: 8.301986694335938,
  Ÿ: 8.301986694335938,
  á: 7.6859893798828125,
  à: 7.6859893798828125,
  ä: 7.6859893798828125,
  â: 7.6859893798828125,
  ã: 7.6859893798828125,
  å: 7.6859893798828125,
  ç: 6.7339935302734375,
  é: 7.3499908447265625,
  è: 7.3499908447265625,
  ë: 7.3499908447265625,
  ê: 7.3499908447265625,
  í: 3.5279998779296875,
  ì: 3.5279998779296875,
  ï: 3.5279998779296875,
  ñ: 7.9799957275390625,
  ó: 7.391998291015625,
  ò: 7.391998291015625,
  ö: 7.391998291015625,
  ô: 7.391998291015625,
  õ: 7.391998291015625,
  ø: 7.391998291015625,
  š: 6.7759857177734375,
  ý: 6.6779937744140625,
  ÿ: 6.6779937744140625,
  A: 8.86199951171875,
  B: 8.707992553710938,
  C: 8.35798645019531,
  D: 8.72200012207031,
  E: 8.105987548828125,
  F: 7.6859893798828125,
  G: 8.735992431640625,
  H: 9.50599670410156,
  I: 5.2220001220703125,
  J: 6.3279876708984375,
  K: 8.49798583984375,
  L: 7.279998779296875,
  M: 11.423995971679688,
  N: 9.589996337890625,
  O: 8.959991455078125,
  P: 8.399993896484375,
  Q: 8.959991455078125,
  R: 8.87599182128906,
  S: 8.27398681640625,
  T: 7.55999755859375,
  U: 9.113998413085938,
  V: 8.72200012207031,
  W: 13.215988159179688,
  X: 9.141998291015625,
  Y: 8.301986694335938,
  Z: 8.45599365234375,
  ' ': 3.47198486328125,
  '!': 4.0319976806640625,
  '"': 5.2079925537109375,
  "'": 3.0659942626953125,
  '#': 8.90399169921875,
  $: 8.04998779296875,
  '%': 10.33198547363281,
  '&': 8.917999267578125,
  '(': 4.787994384765625,
  ')': 4.5359954833984375,
  '*': 7.167999267578125,
  '+': 8.035995483398438,
  ',': 3.47198486328125,
  '-': 6.6079864501953125,
  '.': 3.47198486328125,
  '/': 4.787994384765625,
  ':': 3.47198486328125,
  ';': 3.47198486328125,
  '<': 8.413986206054688,
  '=': 8.035995483398438,
  '>': 8.413986206054688,
  '?': 7.6439971923828125,
  '@': 14.923995971679688,
  '[': 4.73199462890625,
  '\\': 4.787994384765625,
  ']': 4.6479949951171875,
  '^': 8.035995483398438,
  _: 7.951995849609375,
  '`': 3.8499908447265625,
  '{': 5.165985107421875,
  '|': 3.6399993896484375,
  '}': 5.165985107421875,
  '~': 8.035995483398438,
  '•': 6.1039886474609375,
  '…': 10.415985107421875,
  '°': 5.2639923095703125,
  µ: 7.9799957275390625,
  '²': 4.8159942626953125,
  '³': 4.8159942626953125,
  '±': 8.035995483398438,
  '€': 8.04998779296875,
  '£': 8.04998779296875,
  '¥': 8.035995483398438,
};

/**
 * Font size: '14px'
 * Font weight: 500
 * Font family: 'DynatraceFlow, Roboto, Helvetica, sans-serif'
 */
export const charsFontWidth14pixelsSize500Map: FontWidthMap = {
  '0': 8.11999,
  '1': 8.11999,
  '2': 8.11999,
  '3': 8.11999,
  '4': 8.11999,
  '5': 8.11999,
  '6': 8.11999,
  '7': 8.11999,
  '8': 8.11999,
  '9': 8.11999,
  a: 7.811999,
  b: 7.867986,
  c: 6.817993,
  d: 7.867986,
  e: 7.475988,
  f: 5.348,
  g: 7.797988,
  h: 8.134,
  i: 3.709992,
  j: 3.821984,
  k: 7.363995,
  l: 4.143985,
  m: 12.501986,
  n: 8.105998,
  o: 7.573987,
  p: 7.867986,
  q: 7.881997,
  r: 5.753991,
  s: 6.929985,
  t: 5.389994,
  u: 8.105998,
  v: 7.055987,
  w: 10.737994,
  x: 7.349986,
  y: 7.013992,
  z: 7.08399,
  á: 7.811999,
  à: 7.811999,
  ä: 7.811999,
  â: 7.811999,
  ã: 7.811999,
  å: 7.811999,
  ç: 6.817993,
  é: 7.475988,
  è: 7.475988,
  ë: 7.475988,
  ê: 7.475988,
  í: 3.709992,
  ì: 3.709992,
  ï: 3.709992,
  ñ: 8.105998,
  ó: 7.573987,
  ò: 7.573987,
  ö: 7.573987,
  ô: 7.573987,
  õ: 7.573987,
  ø: 7.573987,
  š: 6.929985,
  ý: 7.013992,
  ÿ: 7.013992,
  Z: 8.511988,
  A: 9.029988,
  Á: 9.029988,
  À: 9.029988,
  Ä: 9.029988,
  Â: 9.029988,
  Ã: 9.029988,
  Å: 9.029988,
  B: 8.75,
  C: 8.455984,
  Ç: 8.455984,
  D: 8.917997,
  E: 8.232,
  É: 8.232,
  È: 8.232,
  Ë: 8.232,
  Ê: 8.232,
  F: 7.825992,
  G: 8.848,
  H: 9.673991,
  I: 5.403987,
  Í: 5.403987,
  Ì: 5.403987,
  Ï: 5.403987,
  J: 6.46799,
  K: 8.75,
  L: 7.349986,
  ' ': 3.58399,
  M: 11.81599,
  N: 9.799993,
  Ñ: 9.799993,
  O: 9.141999,
  Ó: 9.141999,
  Ò: 9.141999,
  Ö: 9.141999,
  Ô: 9.141999,
  Õ: 9.141999,
  Ø: 9.141999,
  P: 8.553983,
  Q: 9.141999,
  R: 8.973984,
  S: 8.483986,
  Š: 8.483986,
  T: 7.671987,
  U: 9.281993,
  Ú: 9.281993,
  Ù: 9.281993,
  Ü: 9.281993,
  V: 8.93199,
  W: 13.579999,
  X: 9.337998,
  Y: 8.441991,
  Ý: 8.441991,
  Ÿ: 8.441991,
  '!': 4.10199,
  '"': 5.529988,
  "'": 3.233986,
  '#': 8.903987,
  $: 8.189987,
  '%': 10.261988,
  '&': 8.805987,
  '(': 4.983986,
  ')': 4.815989,
  '*': 7.461995,
  '+': 8.049993,
  ',': 3.598,
  '-': 6.677999,
  '.': 3.598,
  '/': 5.095995,
  ':': 3.598,
  ';': 3.598,
  '<': 8.287987,
  '=': 8.049993,
  '>': 8.287987,
  '?': 7.769986,
  '@': 14.923991,
  '[': 5.109988,
  '\\': 5.095995,
  ']': 5.039991,
  '^': 8.049993,
  _: 8.11999,
  '`': 4.10199,
  '{': 5.473984,
  '|': 3.891999,
  '}': 5.473984,
  '~': 8.049993,
  '•': 6.131997,
  '…': 10.79399,
  '°': 5.347981,
  µ: 8.105998,
  '²': 4.871994,
  '³': 4.871994,
  '±': 8.049993,
  '€': 8.189987,
  '£': 8.189987,
  '¥': 8.049993,
};

/**
 * These calculations are based on specific font settings using a canvas element for the measurements.
 * Font size: '12px'
 * Font weight 500
 * Font family: 'DynatraceFlow, Roboto, Helvetica, sans-serif'
 */
export const charsFontWidth12pixelsSize500Map: FontWidthMap = {
  '0': 6.959991,
  '1': 6.959991,
  '2': 6.959991,
  '3': 6.959991,
  '4': 6.959991,
  '5': 6.959991,
  '6': 6.959991,
  '7': 6.959991,
  '8': 6.959991,
  '9': 6.959991,
  a: 6.695999,
  b: 6.743988,
  c: 5.843994,
  d: 6.743988,
  e: 6.40799,
  f: 4.584,
  g: 6.68399,
  h: 6.972,
  i: 3.179993,
  j: 3.275986,
  k: 6.311996,
  l: 3.551987,
  m: 10.715988,
  n: 6.947998,
  o: 6.491989,
  p: 6.743988,
  q: 6.755997,
  r: 4.931992,
  s: 5.939987,
  t: 4.619995,
  u: 6.947998,
  v: 6.047989,
  w: 9.203995,
  x: 6.299988,
  y: 6.011993,
  z: 6.071991,
  á: 6.695999,
  à: 6.695999,
  ä: 6.695999,
  â: 6.695999,
  ã: 6.695999,
  å: 6.695999,
  ç: 5.843994,
  é: 6.40799,
  è: 6.40799,
  ë: 6.40799,
  ê: 6.40799,
  í: 3.179993,
  ì: 3.179993,
  ï: 3.179993,
  ñ: 6.947998,
  ó: 6.491989,
  ò: 6.491989,
  ö: 6.491989,
  ô: 6.491989,
  õ: 6.491989,
  ø: 6.491989,
  š: 5.939987,
  ý: 6.011993,
  ÿ: 6.011993,
  Z: 7.29599,
  A: 7.73999,
  Á: 7.73999,
  À: 7.73999,
  Ä: 7.73999,
  Â: 7.73999,
  Ã: 7.73999,
  Å: 7.73999,
  B: 7.5,
  C: 7.247986,
  Ç: 7.247986,
  D: 7.643997,
  E: 7.056,
  É: 7.056,
  È: 7.056,
  Ë: 7.056,
  Ê: 7.056,
  F: 6.707993,
  G: 7.584,
  H: 8.291992,
  I: 4.631989,
  Í: 4.631989,
  Ì: 4.631989,
  Ï: 4.631989,
  J: 5.543991,
  K: 7.5,
  L: 6.299988,
  ' ': 3.071991,
  M: 10.127991,
  N: 8.399994,
  O: 7.835999,
  Ó: 7.835999,
  Ò: 7.835999,
  Ö: 7.835999,
  Ô: 7.835999,
  Õ: 7.835999,
  Ø: 7.835999,
  P: 7.331985,
  Q: 7.835999,
  R: 7.691986,
  S: 7.271988,
  Š: 7.271988,
  T: 6.575989,
  U: 7.955994,
  V: 7.655991,
  W: 11.639999,
  X: 8.003998,
  Y: 7.235992,
  Ý: 7.235992,
  Ÿ: 7.235992,
  '!': 3.515991,
  '"': 4.73999,
  "'": 2.771988,
  '#': 7.631989,
  $: 7.019989,
  '%': 8.79599,
  '&': 7.547989,
  '(': 4.271988,
  ')': 4.127991,
  '*': 6.395996,
  '+': 6.899994,
  ',': 3.084,
  '-': 5.723999,
  '.': 3.084,
  '/': 4.367996,
  ':': 3.084,
  ';': 3.084,
  '<': 7.103989,
  '=': 6.899994,
  '>': 7.103989,
  '?': 6.659988,
  '@': 12.791992,
  '[': 4.37999,
  '\\': 4.367996,
  ']': 4.319992,
  '^': 6.899994,
  _: 6.959991,
  '`': 3.515991,
  '{': 4.691986,
  '|': 3.335999,
  '}': 4.691986,
  '~': 6.899994,
  '•': 5.255997,
  '…': 9.251991,
  '°': 4.583984,
  µ: 6.947998,
  '²': 4.175995,
  '³': 4.175995,
  '±': 6.899994,
  '€': 7.019989,
  '£': 7.019989,
  '¥': 6.899994,
};

/**
 * These calculations are based on specific font settings using a canvas element for the measurements.
 * Font size: '12px'
 * Font weight 600
 * Font family: 'DynatraceFlow, Roboto, Helvetica, sans-serif'
 */
export const charsFontWidth12pixelsSize600Map: FontWidthMap = {
  '0': 7.031998,
  '1': 7.031998,
  '2': 7.031998,
  '3': 7.031998,
  '4': 7.031998,
  '5': 7.031998,
  '6': 7.031998,
  '7': 7.031998,
  '8': 7.031998,
  '9': 7.031998,
  a: 6.815994,
  b: 6.911987,
  c: 5.927994,
  d: 6.911987,
  e: 6.539993,
  f: 4.811996,
  g: 6.875992,
  h: 7.115997,
  i: 3.359985,
  j: 3.479996,
  k: 6.623993,
  l: 3.743988,
  m: 10.691986,
  n: 7.079987,
  o: 6.659988,
  p: 6.911987,
  q: 6.923996,
  r: 5.18399,
  s: 6.095993,
  t: 4.82399,
  u: 7.079987,
  v: 6.275986,
  w: 9.612,
  x: 6.671997,
  y: 6.347992,
  z: 6.191986,
  á: 6.815994,
  à: 6.815994,
  ä: 6.815994,
  â: 6.815994,
  ã: 6.815994,
  å: 6.815994,
  ç: 5.927994,
  é: 6.539993,
  è: 6.539993,
  ë: 6.539993,
  ê: 6.539993,
  í: 3.359985,
  ì: 3.359985,
  ï: 3.359985,
  ñ: 7.079987,
  ó: 6.659988,
  ò: 6.659988,
  ö: 6.659988,
  ô: 6.659988,
  õ: 6.659988,
  ø: 6.659988,
  š: 6.095993,
  ý: 6.347992,
  ÿ: 6.347992,
  Z: 7.367996,
  A: 7.895996,
  Á: 7.895996,
  À: 7.895996,
  Ä: 7.895996,
  Â: 7.895996,
  Ã: 7.895996,
  Å: 7.895996,
  B: 7.547989,
  C: 7.343994,
  Ç: 7.343994,
  D: 7.82399,
  E: 7.175995,
  É: 7.175995,
  È: 7.175995,
  Ë: 7.175995,
  Ê: 7.175995,
  F: 6.85199,
  G: 7.703995,
  H: 8.447998,
  I: 4.811996,
  Í: 4.811996,
  Ì: 4.811996,
  Ï: 4.811996,
  J: 5.687988,
  K: 7.73999,
  L: 6.371994,
  ' ': 3.167999,
  M: 10.523987,
  N: 8.615997,
  O: 8.015991,
  Ó: 8.015991,
  Ò: 8.015991,
  Ö: 8.015991,
  Ô: 8.015991,
  Õ: 8.015991,
  Ø: 8.015991,
  P: 7.487991,
  Q: 8.015991,
  R: 7.787994,
  S: 7.475998,
  Š: 7.475998,
  T: 6.68399,
  U: 8.112,
  V: 7.859985,
  W: 11.987991,
  X: 8.195999,
  Y: 7.367996,
  Ý: 7.367996,
  Ÿ: 7.367996,
  '!': 3.587997,
  '"': 5.063995,
  "'": 2.951996,
  '#': 7.631989,
  $: 7.163986,
  '%': 8.735992,
  '&': 7.427994,
  '(': 4.463989,
  ')': 4.391998,
  '*': 6.695999,
  '+': 6.923996,
  ',': 3.215988,
  '-': 5.79599,
  '.': 3.215988,
  '/': 4.679993,
  ':': 3.215988,
  ';': 3.215988,
  '<': 6.983994,
  '=': 6.923996,
  '>': 6.983994,
  '?': 6.791992,
  '@': 12.791992,
  '[': 4.763992,
  '\\': 4.679993,
  ']': 4.703995,
  '^': 6.923996,
  _: 7.115997,
  '`': 3.76799,
  '{': 5.003998,
  '|': 3.575989,
  '}': 5.003998,
  '~': 6.923996,
  '•': 5.291992,
  '…': 9.647988,
  '°': 4.655991,
  µ: 7.079987,
  '²': 4.223999,
  '³': 4.223999,
  '±': 6.923996,
  '€': 7.163986,
  '£': 7.163986,
  '¥': 6.923996,
};

/**
 * These calculations are based on specific font settings using a canvas element for the measurements.
 * Font size: '12px'
 * Font weight 700
 * Font family: 'DynatraceFlow, Roboto, Helvetica, sans-serif'
 */
export const charsFontWidth12pixelsSize700Map: FontWidthMap = {
  '0': 6.673828,
  '1': 6.673828,
  '2': 6.673828,
  '3': 6.673828,
  '4': 6.673828,
  '5': 6.673828,
  '6': 6.673828,
  '7': 6.673828,
  '8': 6.673828,
  '9': 6.673828,
  a: 6.673828,
  b: 7.330078,
  c: 6.673828,
  d: 7.330078,
  e: 6.673828,
  f: 3.996094,
  g: 7.330078,
  h: 7.330078,
  i: 3.333984,
  j: 3.333984,
  k: 6.673828,
  l: 3.333984,
  m: 10.669922,
  n: 7.330078,
  o: 7.330078,
  p: 7.330078,
  q: 7.330078,
  r: 4.669922,
  s: 6.673828,
  t: 3.996094,
  u: 7.330078,
  v: 6.673828,
  w: 9.333984,
  x: 6.673828,
  y: 6.673828,
  z: 6,
  á: 6.673828,
  à: 6.673828,
  ä: 6.673828,
  â: 6.673828,
  ã: 6.673828,
  å: 6.673828,
  ç: 6.673828,
  é: 6.673828,
  è: 6.673828,
  ë: 6.673828,
  ê: 6.673828,
  í: 3.333984,
  ì: 3.333984,
  ï: 3.333984,
  ñ: 7.330078,
  ó: 7.330078,
  ò: 7.330078,
  ö: 7.330078,
  ô: 7.330078,
  õ: 7.330078,
  ø: 7.330078,
  š: 6.673828,
  ý: 6.673828,
  ÿ: 6.673828,
  Z: 7.330078,
  A: 8.666016,
  Á: 8.666016,
  À: 8.666016,
  Ä: 8.666016,
  Â: 8.666016,
  Ã: 8.666016,
  Å: 8.666016,
  B: 8.666016,
  C: 8.666016,
  Ç: 8.666016,
  D: 8.666016,
  E: 8.003906,
  É: 8.003906,
  È: 8.003906,
  Ë: 8.003906,
  Ê: 8.003906,
  F: 7.330078,
  G: 9.333984,
  H: 8.666016,
  I: 3.333984,
  Í: 3.333984,
  Ì: 3.333984,
  Ï: 3.333984,
  J: 6.673828,
  K: 8.666016,
  L: 7.330078,
  ' ': 3.333984,
  M: 9.996094,
  N: 8.666016,
  O: 9.333984,
  Ó: 9.333984,
  Ò: 9.333984,
  Ö: 9.333984,
  Ô: 9.333984,
  Õ: 9.333984,
  Ø: 9.333984,
  P: 8.003906,
  Q: 9.333984,
  R: 8.666016,
  S: 8.003906,
  Š: 8.003906,
  T: 7.330078,
  U: 8.666016,
  V: 8.003906,
  W: 11.326172,
  X: 8.003906,
  Y: 8.003906,
  Ý: 8.003906,
  Ÿ: 8.003906,
  '!': 3.996094,
  '"': 5.689453,
  "'": 2.853516,
  '#': 6.673828,
  $: 6.673828,
  '%': 10.669922,
  '&': 8.666016,
  '(': 3.996094,
  ')': 3.996094,
  '*': 4.669922,
  '+': 7.007813,
  ',': 3.333984,
  '-': 3.996094,
  '.': 3.333984,
  '/': 3.333984,
  ':': 3.996094,
  ';': 3.996094,
  '<': 7.007813,
  '=': 7.007813,
  '>': 7.007813,
  '?': 7.330078,
  '@': 11.701172,
  '[': 3.996094,
  '\\': 3.333984,
  ']': 3.996094,
  '^': 7.007813,
  _: 6.673828,
  '`': 3.996094,
  '{': 4.669922,
  '|': 3.357422,
  '}': 4.669922,
  '~': 7.007813,
  '•': 4.201172,
  '…': 10.001953,
  '°': 4.669922,
  µ: 7.330078,
  '²': 4.001953,
  '³': 4.001953,
  '±': 7.007813,
  '€': 6.673828,
  '£': 6.673828,
  '¥': 7.007813,
};

/**
 * Font size: '9px'
 * Font weight: 500
 * Font family: 'DynatraceFlow, Roboto, Helvetica, sans-serif'
 * NOTE: Values scaled from 12px/500 map. Regenerate with buildFontWidthMap({ fontSize: 9, fontWeight: 500 }) for exact measurements.
 */
export const charsFontWidth9pixelsSize500Map: FontWidthMap = {
  '0': 5.219993,
  '1': 5.219993,
  '2': 5.219993,
  '3': 5.219993,
  '4': 5.219993,
  '5': 5.219993,
  '6': 5.219993,
  '7': 5.219993,
  '8': 5.219993,
  '9': 5.219993,
  a: 5.021999,
  b: 5.057991,
  c: 4.382995,
  d: 5.057991,
  e: 4.805993,
  f: 3.438,
  g: 5.012992,
  h: 5.229,
  i: 2.384995,
  j: 2.45699,
  k: 4.733997,
  l: 2.66399,
  m: 8.036991,
  n: 5.210999,
  o: 4.868992,
  p: 5.057991,
  q: 5.066998,
  r: 3.698994,
  s: 4.45499,
  t: 3.464996,
  u: 5.210999,
  v: 4.535992,
  w: 6.902996,
  x: 4.724991,
  y: 4.508995,
  z: 4.553993,
  á: 5.021999,
  à: 5.021999,
  ä: 5.021999,
  â: 5.021999,
  ã: 5.021999,
  å: 5.021999,
  ç: 4.382995,
  é: 4.805993,
  è: 4.805993,
  ë: 4.805993,
  ê: 4.805993,
  í: 2.384995,
  ì: 2.384995,
  ï: 2.384995,
  ñ: 5.210999,
  ó: 4.868992,
  ò: 4.868992,
  ö: 4.868992,
  ô: 4.868992,
  õ: 4.868992,
  ø: 4.868992,
  š: 4.45499,
  ý: 4.508995,
  ÿ: 4.508995,
  Z: 5.471992,
  A: 5.804992,
  Á: 5.804992,
  À: 5.804992,
  Ä: 5.804992,
  Â: 5.804992,
  Ã: 5.804992,
  Å: 5.804992,
  B: 5.625,
  C: 5.435989,
  Ç: 5.435989,
  D: 5.732998,
  E: 5.292,
  É: 5.292,
  È: 5.292,
  Ë: 5.292,
  Ê: 5.292,
  F: 5.030995,
  G: 5.688,
  H: 6.218994,
  I: 3.473992,
  Í: 3.473992,
  Ì: 3.473992,
  Ï: 3.473992,
  J: 4.157993,
  K: 5.625,
  L: 4.724991,
  ' ': 2.303993,
  M: 7.595993,
  N: 6.299995,
  O: 5.876999,
  Ó: 5.876999,
  Ò: 5.876999,
  Ö: 5.876999,
  Ô: 5.876999,
  Õ: 5.876999,
  Ø: 5.876999,
  P: 5.498989,
  Q: 5.876999,
  R: 5.768989,
  S: 5.453991,
  Š: 5.453991,
  T: 4.931992,
  U: 5.966995,
  V: 5.741993,
  W: 8.729999,
  X: 6.002998,
  Y: 5.426994,
  Ý: 5.426994,
  Ÿ: 5.426994,
  '!': 2.636993,
  '"': 3.554992,
  "'": 2.078991,
  '#': 5.723992,
  $: 5.264992,
  '%': 6.596992,
  '&': 5.660992,
  '(': 3.203991,
  ')': 3.095993,
  '*': 4.796997,
  '+': 5.174996,
  ',': 2.313,
  '-': 4.292999,
  '.': 2.313,
  '/': 3.275997,
  ':': 2.313,
  ';': 2.313,
  '<': 5.327992,
  '=': 5.174996,
  '>': 5.327992,
  '?': 4.994991,
  '@': 9.593994,
  '[': 3.284993,
  '\\': 3.275997,
  ']': 3.239994,
  '^': 5.174996,
  _: 5.219993,
  '`': 2.636993,
  '{': 3.518989,
  '|': 2.501999,
  '}': 3.518989,
  '~': 5.174996,
  '•': 3.941998,
  '…': 6.938993,
  '°': 3.437988,
  µ: 5.210999,
  '²': 3.131996,
  '³': 3.131996,
  '±': 5.174996,
  '€': 5.264992,
  '£': 5.264992,
  '¥': 5.174996,
};

/**
 * Font size: '16px'
 * Font weight: 500
 * Font family: 'DynatraceFlow, Roboto, Helvetica, sans-serif'
 * NOTE: Values scaled from 12px/500 map. Regenerate with buildFontWidthMap({ fontSize: 16, fontWeight: 500 }) for exact measurements.
 */
export const charsFontWidth16pixelsSize500Map: FontWidthMap = {
  '0': 9.279988,
  '1': 9.279988,
  '2': 9.279988,
  '3': 9.279988,
  '4': 9.279988,
  '5': 9.279988,
  '6': 9.279988,
  '7': 9.279988,
  '8': 9.279988,
  '9': 9.279988,
  a: 8.927999,
  b: 8.991984,
  c: 7.791992,
  d: 8.991984,
  e: 8.543987,
  f: 6.112,
  g: 8.911987,
  h: 9.296,
  i: 4.239991,
  j: 4.367981,
  k: 8.415995,
  l: 4.735983,
  m: 14.287984,
  n: 9.263997,
  o: 8.655985,
  p: 8.991984,
  q: 9.007996,
  r: 6.575989,
  s: 7.919983,
  t: 6.159993,
  u: 9.263997,
  v: 8.063985,
  w: 12.271993,
  x: 8.399984,
  y: 8.015991,
  z: 8.095988,
  á: 8.927999,
  à: 8.927999,
  ä: 8.927999,
  â: 8.927999,
  ã: 8.927999,
  å: 8.927999,
  ç: 7.791992,
  é: 8.543987,
  è: 8.543987,
  ë: 8.543987,
  ê: 8.543987,
  í: 4.239991,
  ì: 4.239991,
  ï: 4.239991,
  ñ: 9.263997,
  ó: 8.655985,
  ò: 8.655985,
  ö: 8.655985,
  ô: 8.655985,
  õ: 8.655985,
  ø: 8.655985,
  š: 7.919983,
  ý: 8.015991,
  ÿ: 8.015991,
  Z: 9.727987,
  A: 10.319987,
  Á: 10.319987,
  À: 10.319987,
  Ä: 10.319987,
  Â: 10.319987,
  Ã: 10.319987,
  Å: 10.319987,
  B: 10,
  C: 9.663981,
  Ç: 9.663981,
  D: 10.191996,
  E: 9.408,
  É: 9.408,
  È: 9.408,
  Ë: 9.408,
  Ê: 9.408,
  F: 8.943991,
  G: 10.112,
  H: 11.055989,
  I: 6.175985,
  Í: 6.175985,
  Ì: 6.175985,
  Ï: 6.175985,
  J: 7.391988,
  K: 10,
  L: 8.399984,
  ' ': 4.095988,
  M: 13.503988,
  N: 11.199992,
  O: 10.447999,
  Ó: 10.447999,
  Ò: 10.447999,
  Ö: 10.447999,
  Ô: 10.447999,
  Õ: 10.447999,
  Ø: 10.447999,
  P: 9.77598,
  Q: 10.447999,
  R: 10.255981,
  S: 9.695984,
  Š: 9.695984,
  T: 8.767985,
  U: 10.607992,
  V: 10.207988,
  W: 15.519999,
  X: 10.671997,
  Y: 9.647989,
  Ý: 9.647989,
  Ÿ: 9.647989,
  '!': 4.687988,
  '"': 6.319987,
  "'": 3.695984,
  '#': 10.175985,
  $: 9.359985,
  '%': 11.727987,
  '&': 10.063985,
  '(': 5.695984,
  ')': 5.503988,
  '*': 8.527995,
  '+': 9.199992,
  ',': 4.112,
  '-': 7.631999,
  '.': 4.112,
  '/': 5.823995,
  ':': 4.112,
  ';': 4.112,
  '<': 9.471985,
  '=': 9.199992,
  '>': 9.471985,
  '?': 8.879984,
  '@': 17.055989,
  '[': 5.839987,
  '\\': 5.823995,
  ']': 5.759989,
  '^': 9.199992,
  _: 9.279988,
  '`': 4.687988,
  '{': 6.255981,
  '|': 4.447999,
  '}': 6.255981,
  '~': 9.199992,
  '•': 7.007996,
  '…': 12.335988,
  '°': 6.111979,
  µ: 9.263997,
  '²': 5.567993,
  '³': 5.567993,
  '±': 9.199992,
  '€': 9.359985,
  '£': 9.359985,
  '¥': 9.199992,
};

/**
 * Font size: '18px'
 * Font weight: 400
 * Font family: 'DynatraceFlow, Roboto, Helvetica, sans-serif'
 * NOTE: Values scaled from 12px/500 map. Regenerate with buildFontWidthMap({ fontSize: 18, fontWeight: 400 }) for exact measurements.
 */
export const charsFontWidth18pixelsSize400Map: FontWidthMap = {
  '0': 10.0107421875,
  '1': 10.0107421875,
  '2': 10.0107421875,
  '3': 10.0107421875,
  '4': 10.0107421875,
  '5': 10.0107421875,
  '6': 10.0107421875,
  '7': 10.0107421875,
  '8': 10.0107421875,
  '9': 10.0107421875,
  a: 10.0107421875,
  á: 10.0107421875,
  à: 10.0107421875,
  ä: 10.0107421875,
  â: 10.0107421875,
  ã: 10.0107421875,
  å: 10.0107421875,
  b: 10.0107421875,
  c: 9,
  ç: 9,
  d: 10.0107421875,
  e: 10.0107421875,
  é: 10.0107421875,
  è: 10.0107421875,
  ë: 10.0107421875,
  ê: 10.0107421875,
  f: 5.0009765625,
  g: 10.0107421875,
  h: 10.0107421875,
  i: 3.9990234375,
  í: 5.0009765625,
  ì: 5.0009765625,
  ï: 5.0009765625,
  j: 3.9990234375,
  k: 9,
  l: 3.9990234375,
  m: 14.994140625,
  n: 10.0107421875,
  ñ: 10.0107421875,
  o: 10.0107421875,
  ó: 10.0107421875,
  ò: 10.0107421875,
  ö: 10.0107421875,
  ô: 10.0107421875,
  õ: 10.0107421875,
  ø: 10.9951171875,
  p: 10.0107421875,
  q: 10.0107421875,
  r: 5.994140625,
  s: 9,
  š: 9,
  t: 5.0009765625,
  u: 10.0107421875,
  ú: 10.0107421875,
  ù: 10.0107421875,
  ü: 10.0107421875,
  v: 9,
  w: 12.9990234375,
  x: 9,
  y: 9,
  ý: 9,
  ÿ: 9,
  z: 9,
  A: 12.005859375,
  Á: 12.005859375,
  À: 12.005859375,
  Ä: 12.005859375,
  Â: 12.005859375,
  Ã: 12.005859375,
  Å: 12.005859375,
  B: 12.005859375,
  C: 12.9990234375,
  Ç: 12.9990234375,
  D: 12.9990234375,
  E: 12.005859375,
  É: 12.005859375,
  È: 12.005859375,
  Ë: 12.005859375,
  Ê: 12.005859375,
  F: 10.9951171875,
  G: 14.0009765625,
  H: 12.9990234375,
  I: 5.0009765625,
  Í: 5.0009765625,
  Ì: 5.0009765625,
  Ï: 5.0009765625,
  J: 9,
  K: 12.005859375,
  L: 10.0107421875,
  M: 14.994140625,
  N: 12.9990234375,
  Ñ: 12.9990234375,
  O: 14.0009765625,
  Ó: 14.0009765625,
  Ò: 14.0009765625,
  Ö: 14.0009765625,
  Ô: 14.0009765625,
  Õ: 14.0009765625,
  Ø: 14.0009765625,
  P: 12.005859375,
  Q: 14.0009765625,
  R: 12.9990234375,
  S: 12.005859375,
  Š: 12.005859375,
  T: 10.9951171875,
  U: 12.9990234375,
  Ú: 12.9990234375,
  Ù: 12.9990234375,
  Ü: 12.9990234375,
  V: 12.005859375,
  W: 16.9892578125,
  X: 12.005859375,
  Y: 12.005859375,
  Ý: 12.005859375,
  Ÿ: 12.005859375,
  Z: 10.9951171875,
  ' ': 5.0009765625,
  '!': 5.0009765625,
  '"': 6.3896484375,
  '#': 10.0107421875,
  $: 10.0107421875,
  '%': 16.0048828125,
  '&': 12.005859375,
  "'": 3.4365234375,
  '(': 5.994140625,
  ')': 5.994140625,
  '*': 7.0048828125,
  '+': 10.51171875,
  ',': 5.0009765625,
  '-': 5.994140625,
  '.': 5.0009765625,
  '/': 5.0009765625,
  ':': 5.0009765625,
  ';': 5.0009765625,
  '<': 10.51171875,
  '=': 10.51171875,
  '>': 10.51171875,
  '?': 10.0107421875,
  '@': 18.2724609375,
  '[': 5.0009765625,
  '\\': 5.0009765625,
  ']': 5.0009765625,
  '^': 8.4462890625,
  _: 10.0107421875,
  '`': 5.994140625,
  '{': 6.01171875,
  '|': 4.67578125,
  '}': 6.01171875,
  '~': 10.51171875,
  '•': 6.3017578125,
  '…': 18,
  '°': 7.1982421875,
  µ: 10.37109375,
  '²': 5.994140625,
  '³': 5.994140625,
  '±': 9.87890625,
  '€': 13.39453125,
  '£': 10.0107421875,
  '¥': 10.0107421875,
};
